import request from '@/utils/request'

export function getArticleList (data) {
  return request({
    url: '/Artilce/GetArticleList',
    method: 'get'
  })
}

export function getArticle (data) {
  return request({
    url: '/Artilce/GetArticle',
    method: 'get',
    params: data
  })
}
